import { applyMiddleware, combineReducers, compose, createStore } from 'redux';
import { all } from 'redux-saga/effects';
import createSagaMiddleware from 'redux-saga';
import { connectRouter, routerMiddleware } from 'connected-react-router';
import { createHashHistory } from 'history';
import { parse } from 'query-string';

import { getApi, setApi, setScormApi } from '../api';
import appSaga from './app/sagas';
import appReducer from './app/reducers';
import dashboardReducer from './dashboard/reducers';
import portalSaga from './portal/sagas';
import portalReducer from './portal/reducers';
import userSaga from './user/sagas';
import userReducer from './user/reducers';
import diariesSaga from './diaries/sagas';
import diariesReducer from './diaries/reducers';
import timelineSaga from './timeline/sagas';
import timelineReducer from './timeline/reducers';
import librarySaga from './library/sagas';
import libraryReducer from './library/reducers';
import dashboardSaga from './dashboard/sagas';
import rapportageSaga from './rapportage/sagas';
import rapportageReducer from './rapportage/reducers';

import { rootProps } from '../root';
import { API_SCHEMA_URL } from '../variables';

const history = createHashHistory();
const sagaMiddleware = createSagaMiddleware();
const middlewares = [routerMiddleware(history), sagaMiddleware];

if (process.env.NODE_ENV === `development`) {
  const { logger } = require(`redux-logger`);
  middlewares.push(logger);
}

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
const enhancer = composeEnhancers(applyMiddleware(...middlewares));

const hash = window.location.hash;
const hashQuery =
  hash.indexOf('?') !== -1 ? hash.slice(hash.indexOf('?')) : null;
const queryParams = parse(window.location.search);
const hashQueryParams = parse(hashQuery);
const nextUrl =
  hashQueryParams.nextUrl ||
  hashQueryParams.lmshref ||
  queryParams.nextUrl ||
  queryParams.lmshref ||
  null;

const rootReducer = combineReducers({
  ...appReducer,
  ...dashboardReducer,
  ...portalReducer,
  ...userReducer,
  ...diariesReducer,
  ...timelineReducer,
  ...libraryReducer,
  ...rapportageReducer,
  nextUrl: (state = nextUrl) => state,
  router: connectRouter(history)
});

if (!rootProps.lmsPreview) {
  if (rootProps.scorm) {
    setScormApi();
  } else {
    setApi(API_SCHEMA_URL);
  }
} else if (rootProps.scorm) {
  localStorage.setItem(
    'content',
    JSON.stringify(window[rootProps.lmsPreview].content)
  );
  localStorage.setItem(
    'modules',
    JSON.stringify(
      window[rootProps.lmsPreview].children.map(m => ({
        ...m,
        media_url: ''
      }))
    )
  );
  setScormApi(false);
}

const store = createStore(
  rootReducer,
  {
    // moduleContent:
    //   rootProps.lmsPreview && !rootProps.scorm
    //     ? { [window[rootProps.lmsPreview].uuid]: window[rootProps.lmsPreview] }
    //     : {}
  },
  enhancer
);

function* rootSaga() {
  yield all([
    appSaga(),
    portalSaga(),
    userSaga(),
    diariesSaga(),
    timelineSaga(),
    librarySaga(),
    dashboardSaga(),
    rapportageSaga()
  ]);
}

getApi().apiPromise.then(() => {
  sagaMiddleware.run(rootSaga);
});

export { store, history };
